import { render, staticRenderFns } from "./SvgMusic.vue?vue&type=template&id=296d8174&"
import script from "./SvgMusic.vue?vue&type=script&lang=js&"
export * from "./SvgMusic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports